var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-layout',{attrs:{"layout":"C"}},[_c('div',{staticClass:"layout-result",staticStyle:{"height":"100%","margin-top":"5px","overflow-y":"auto"}},[_c('el-form',{ref:"refForm",attrs:{"model":_vm.form,"rules":_vm.rules,"size":"small"},nativeOn:{"submit":function($event){$event.preventDefault();}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }